import { apiPost } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { ExtendedVehicleCostMonthlyRow } from '../../../common/application/model/VehicleCostMonthlyRow';
import { buildQuery } from '../../framework/client/resource';

export async function getVehicleCostMonthlyRows(
    parameters: Map<string, string>,
    specialParameters?: Map<string, any>,
): Promise<{
    vehicleCostMonthlyRows: ExtendedVehicleCostMonthlyRow[];
    total: number;
}> {
    let body: any = {};
    let queryParameters = '';

    const pagingParameters = new Map<string, string>();
    let queryString = ``;

    if (parameters) {
        const query = buildQuery(parameters, queryString, body, pagingParameters, '');
        queryParameters = query.queryParameters;
        body = query.body;
    }

    queryParameters += specialParameters
        ? '&' + Array.from(specialParameters, ([key, value]) => encodeURI(key) + '=' + encodeURI(value)).join('&')
        : '';

    const response = await apiPost(`/api/manager/vehicle-cost-monthly-row${queryParameters}`, body);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function exportPeriodBalance(
    parameters: Map<string, string>,
    specialParameters?: Map<string, any>,
): Promise<{ fileName: string }> {
    let body: any = {};
    let queryParameters = '';

    const pagingParameters = new Map<string, string>();
    let queryString = ``;

    if (parameters) {
        const query = buildQuery(parameters, queryString, body, pagingParameters, '');
        queryParameters = query.queryParameters;
        body = query.body;
    }

    queryParameters += specialParameters
        ? '&' + Array.from(specialParameters, ([key, value]) => encodeURI(key) + '=' + encodeURI(value)).join('&')
        : '';

    const response = await apiPost(`/api/manager/vehicle-cost-monthly-row/export${queryParameters}`, body);

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
